import React, { useState } from 'react';
import { Link } from 'react-router-dom';
//Styles
import './Services.css';
//Data
import  { SERVICES }  from '../../shared/services';
import ReactCardFlip from 'react-card-flip';
//Component
import Header from '../Header/Header';

const FlipServices = ({service}) => {

    const [isFlipped, setIsFlipped] = useState(false);
    const details = service.details.map(detail => <h3>{detail}</h3>)

    return (
        <ReactCardFlip isFlipped={isFlipped} flipDirection="horizontal" className="flipcard">
            <div onMouseEnter={() => setIsFlipped((prev) => !prev)} className="services__card__front">
                <div className="service__image"><img src={service.image} alt="service" /></div>
                <h1>{service.name}</h1>
                <div className="service__details"><h3>{details}</h3></div>
            </div>
            <div onMouseLeave={() => setIsFlipped((prev) => !prev)} className="services__card__back">
                <h3>{service.description}</h3>
            </div>
        </ReactCardFlip>
    );
}



const Services = () => {

    const services = SERVICES;
    const renderServices = services.map(service => <FlipServices service={service} key={service.id} />);

    return(
        <>
            <Header color={'var(--DarkNavy)'} barColor={'var(--Blue)'} bg={'block'}/>
            <div className="services__wrapper">
                <div className="services__content">
                    <div className="services__text">
                        <h1>Meet Our Services</h1>
                        <h2>We can help you grow your products/services globally <br/>by 3 main services below. <br/>Meet our best quality services.</h2>
                    </div>
                    <div className="services__cards">
                        {renderServices}
                    </div>
                    <Link to='/quote' className="services__quote__button"><button>Request A Quote</button></Link>
                </div>
            </div>
        </>
    )
}


export default Services;